import { format } from "date-fns";

const createTimeFormat = (date: string | undefined) => {
	if (date) {
		return format(new Date(date), "yyyy년 MM월 dd일");
	}
};

const createDayTimeFormat = (date: string) => {
	if (!date) {
		return "-";
	}

	return format(new Date(date), "yyyy년 MM월 dd일 aahh:mm");
};

export { createTimeFormat, createDayTimeFormat };
